import { getStatusPresentation } from '@lib/social/scheduling/posts';
import classNames from 'classnames';
import css from './StatusPill.module.scss';

/** A post's status as a labelled pill, or as a bare dot where a chip has no room for words. */
export function StatusPill({
  status,
  compact = false,
}: {
  /** One of `SocialPostStatus`, or a value newer than this client, which renders as itself in neutral. */
  status: string;
  compact?: boolean;
}) {
  const { label, tone } = getStatusPresentation(status);
  return (
    <span
      className={classNames(compact ? css.dot : css.pill, css[tone])}
      title={compact ? label : undefined}
      aria-label={compact ? label : undefined}
    >
      {!compact && label}
    </span>
  );
}
